module.exports = __webpack_public_path__ + "static/media/palette.91988feb.svg";